import { useEffect, useRef } from 'react';

export function useDocumentTitle(title: string) {
  const defaultTitle = useRef(document.title);

  useEffect(() => {
    // Save the current title to restore later if needed
    const previousTitle = document.title;

    // Update the document title
    document.title = title;

    // Cleanup function to restore the title when component unmounts
    return () => {
      document.title = previousTitle;
    };
  }, [title]);

  // Optional: restore default title on unmount
  useEffect(() => {
    return () => {
      document.title = defaultTitle.current;
    };
  }, []);
};
